import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { ConnectFormDirective } from './directives/connect.form.directive';
import { AutoScrollToDirective } from './directives/auto-scroll-to.directive';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { FixedHeightSidenavComponent } from './components/fixed-height-sidenav/fixed-height-sidenav.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { DropFileDirective } from './directives/drop-file.directive';
import { MatSelectModule } from '@angular/material/select';
import { RankLabelComponent } from './components/rank-label/rank-label.component';
import { DayOfWeekSelectionComponent } from './components/day-of-week-selection/day-of-week-selection.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { HistoryComponent } from './components/history/history.component';
import { MatListModule } from '@angular/material/list';
import { FeaturesSelectionComponent } from './components/features-selection/features-selection.component';
import { MatBadge } from "@angular/material/badge";
import { MatLine } from "@angular/material/core";
import { MatTooltip } from "@angular/material/tooltip";
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { SettingsMenuComponent } from './components/settings-menu/settings-menu.component';
import { AccountMenuComponent } from './components/account-menu/account-menu.component';
import { TranslateModule } from '@ngx-translate/core';

const sharedMaterialModules = [
  MatFormFieldModule,
  MatIconModule,
  MatCardModule,
  MatInputModule,
  MatButtonModule,
  MatSelectModule,
  MatListModule,
  MatMenuModule,
];

const sharedModules = [CommonModule, RouterModule, ReactiveFormsModule, ...sharedMaterialModules];

@NgModule({
  declarations: [
    ConnectFormDirective,
    AutoScrollToDirective,
    ErrorMessageComponent,
    FixedHeightSidenavComponent,
    PageHeaderComponent,
    DropFileDirective,
    RankLabelComponent,
    DayOfWeekSelectionComponent,
    HistoryComponent,
    FeaturesSelectionComponent,
    SettingsMenuComponent,
    AccountMenuComponent,
  ],
  imports: [...sharedModules, MatCheckboxModule, MatBadge, MatLine, MatTooltip, MatDividerModule, TranslateModule],
  providers: [
    provideHttpClient(withInterceptorsFromDi())
  ],
  exports: [
    ...sharedModules,
    ConnectFormDirective,
    AutoScrollToDirective,
    ErrorMessageComponent,
    FixedHeightSidenavComponent,
    PageHeaderComponent,
    DropFileDirective,
    RankLabelComponent,
    DayOfWeekSelectionComponent,
    HistoryComponent,
    FeaturesSelectionComponent,
    SettingsMenuComponent,
    AccountMenuComponent,
  ],
})
export class SharedModule {}
